import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
const firebaseConfig = {
  apiKey: "AIzaSyA3BINlQTNy_Akek9blroT0X8bCYG4MqB0",
  authDomain: "angel-games-studio.firebaseapp.com",
  projectId: "angel-games-studio",
  storageBucket: "angel-games-studio.appspot.com",
  messagingSenderId: "746380195359",
  appId: "1:746380195359:web:5ddaa9880c7c326d72872a",
  measurementId: "G-P9DEZE4TWQ"
};

const app = initializeApp(firebaseConfig);
export const firestore = getFirestore(app);
export const storage = getStorage(app);
